import { createWebClient, IFetchQuery } from "@cd2/skeem-client"
import { useApi } from "../hooks/useApi"

declare global {
  interface Window {
    skeem: ReturnType<typeof createWebClient>
    api: ReturnType<typeof useApi>
  }
}
export const skeem = createWebClient({ url: "/skeem", dateObjects: false })
window.skeem = skeem

export async function fetchWithTotalCount<T>(query: IFetchQuery) {
  const model = Object.keys(query)[0]
  const filter = query[model].filter

  const resultsPromise = skeem.fetch<T>(query)

  const totalCountPromise = skeem.fetch({
    $: {
      count: { [model]: { filter } },
    },
  })

  // we use Promise.all here so the two requests are batched together
  const [records, count] = await Promise.all([resultsPromise, totalCountPromise])

  return { records, count }
}
